import { useEffect } from "react";
import { conditions } from "../../conditions/conditions";
import { ConditionName } from "../../../interfaces/enums";
import { apiCaller } from "../../../services/apiCaller";
import { API } from "../../../services/services";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { setRecommendationList } from "../../../redux/slices/videoDataSlice";
import { responseValidator } from "../../helpers";
import { shallowEqual } from 'react-redux'

const useGetRecommendationList = () => {

    const dispatch = useAppDispatch();
    const { isFetchDetails } = useAppSelector(({ videoData: { isFetchDetails, params } }) => ({ isFetchDetails, params }), shallowEqual);
    const {loadedFragmentsCount} = useAppSelector(({ controller: { loadedFragmentsCount } }) => ({ loadedFragmentsCount }), shallowEqual);

    useEffect(() => {
        if (conditions(ConditionName.getRecommendationList) && conditions(ConditionName.hasPermittedLoadedFragment)) {
            (async () => {
                const { data, status } = await apiCaller({ url: API().recommendationList() });
                if (responseValidator(status)) dispatch(setRecommendationList(data));
            })()
        }
    }, [isFetchDetails, loadedFragmentsCount.length])
}

export default useGetRecommendationList;